/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import '../../less/components/log-search.less';

angular.module('avi/logs').directive('logSearch', function() {
    //have to use simple eventSearch inside, can't move completely
    return {
        restrict: 'E',
        scope: false,
        templateUrl: 'src/views/application/partials/log-search.html',
    };
});
